export const en = {
    yourOrder: 'Your Order',
    welcome: 'Welcome!',
    subtotal: 'Subtotal (including Tax):',
    discount: 'Discount:',
    tax: 'Tax:',
    remainingPayment: 'Remaining Payment:',
    refundDue: 'Refund due:',
    change: 'Change:',
    login: 'Login with your Microsoft Account',
    invalidTenant: 'Invalid tenant',
    invalidTenantMessage: 'We could not verify this tenant. Please check the link or contact support.',
    missingTenant: 'Missing tenant parameter',
    missingTenantMessage: 'Please open the app with a URL like:',
    backToSetup: 'Back to Setup',
    backToSetupQuestion: 'Do you want to go back to setup?',
    resetApp: 'Reset the display',
    resetAppQuestion: 'Clear all saved settings and sign-in data stored on this device?',
    cancel: 'Cancel',
    confirm: 'Confirm',
    selectEnvironment: 'Select an environment',
    selectCompany: 'Select a company',
    selectPosUnit: 'Select a POS Unit',
    environment: 'Environment:',
    company: 'Company:',
    posUnit: 'POS Unit:',
    changeEnvironment: 'Change environment',
    changeCompany: 'Change company',
    changePosUnit: 'Change POS unit',
    lineOrder: 'Line order:',
    newestFirst: 'Newest first',
    oldestFirst: 'Oldest first',
    setInUrl: (setting) => `Set in the URL (${setting}) — change it there.`,
    standbyAfterSale: 'Standby after sale:',
    seconds: 'seconds',
    displayUrl: 'Display URL:',
    copyUrl: 'Copy URL',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    autoConfirmPaused: "The display won't autostart until you press Confirm.",
    switchAccount: 'Switch Microsoft account',
    clear: 'Clear',
    urlSettingsTitle: 'What can be set in the URL',
    urlTenant: 'Microsoft tenant ID (required)',
    urlPreselect: 'Preselect the setup steps',
    urlAutoConfirm: 'Skip this page on start',
    urlLineOrder: 'newestFirst or oldestFirst',
    urlStandbyDelay: 'Seconds a finished sale stays on screen, default 180',
    urlColors: '6-digit hex colour without #, e.g. 75153b',
    urlLang: 'da Danish, de German, no Norwegian, otherwise English',
    urlCrane: 'On-premise mode',
    urlOnPremiseLogin: 'On-premise login, together with environment and company',
    urlReset: 'Alone in the URL: clears the settings and sign-in data stored on this device',
    holdToReturn: 'In the app, hold anywhere on the screen for 5 seconds to return to setup.',
    missingTenantInUrl: 'Missing tenant in URL. Open app with ?tenant=<MS tenant id>.',
    fetchEnvironmentsFailed: 'Could not fetch environments on this tenant either due to a network error or missing permissions.',
    fetchCompaniesFailed: 'Could not fetch companies on this tenant either due to a network error or missing permissions.',
    fetchPosUnitsFailed: 'Could not fetch POS Units on this tenant either due to a network error or missing permissions.',
    autoStartMissing: (settings) => `Auto-start stopped: the URL is missing ${settings}.`,
    autoStartNotFound: (setting, urlValue) => `Auto-start stopped: ${setting} '${urlValue}' from the URL was not found.`,
};
